import * as React from "react";

function SvgIconArrow(props) {
  return (
    <svg width={18} height={12} {...props}>
      <path
        className="arrow-svg__path"
        fill="none"
        stroke="#5267DF"
        strokeWidth={3}
        d="M1 1l8 8 8-8"
      />
    </svg>
  );
}

export default SvgIconArrow;
